{
  "deprecatedBrowser": "브라우저는 지원되지 않습니다.",
  "deprecatedBrowserHelpText": "최고의 경험을 보장하려면 브라우저를 최신 버전으로 업데이트하십시오."
}
